import type { DocumentaryResourceVM } from "@shared-kernel/domain/types/documentary-resource";

export interface DocumentaryResourceCategoryGroup {
  category: string;
  resources: DocumentaryResourceVM[];
}

// Groupe les ressources par `category` en conservant l'ordre d'arrivée
// (l'API renvoie déjà trié par category puis title).
export const groupResourcesByCategory = (resources: DocumentaryResourceVM[]): DocumentaryResourceCategoryGroup[] => {
  const groups: DocumentaryResourceCategoryGroup[] = [];
  const byCategory = new Map<string, DocumentaryResourceCategoryGroup>();

  for (const resource of resources) {
    const existing = byCategory.get(resource.category);
    if (existing) {
      existing.resources.push(resource);
    } else {
      const group: DocumentaryResourceCategoryGroup = { category: resource.category, resources: [resource] };
      byCategory.set(resource.category, group);
      groups.push(group);
    }
  }

  return groups;
};
